export const getLiter = (index: number) => {
  let i = index;
  const literCodes: number[] = [];
  const startLiter = 'A'.charCodeAt(0);
  const maxLiters = 26;

  do {
    const literIndex = i % maxLiters;
    literCodes.unshift(literIndex + startLiter);
    i = (i - literIndex) / maxLiters;
  } while (i > 0);

  if (literCodes.length > 1) {
    literCodes[0]! -= 1;
  }

  return String.fromCharCode(...literCodes);
};
